import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button, Image, Row, Col, Modal } from 'antd';
import toastr from 'toastr';
import moment from 'moment';
import { jobseekerAdminApi } from '../../../api';
import { getRequest, postRequest } from '../../../api/http';
import { LoadingView } from '../../common';
import PdfImg from '../../../assets/images/pdf.png';
import './ResumeViewPO.scss';
import placementOfficer from '../../../api/placementOfficer';

export default function ResumeViewPO() {
  const { stdid } = useParams()

  const navigate = useNavigate();
  const location = useLocation();
  const userId = useParams();
  const eventId = location.state?.eventId;
  let profileUser = location?.state
  const [loading, setloading] = useState(true)
  const [studentInfo, setStudentInfo] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false)
  const userRole = localStorage.getItem('role')
  console.log("userId", userId);
  console.log("studentInfo", studentInfo);
  const fetchStudentsDetails = async () => {
    try {
      // eslint-disable-next-line no-unused-vars
      const response = await getRequest(placementOfficer.getStudentById(eventId, stdid));
      // const response = await pathUrl;
      setStudentInfo(response);
      setloading(false)
    } catch (e) {
      toastr.error(e.message);
      setStudentInfo([]);

    } finally {
      setloading(false)
    }
  };

  useEffect(() => {

    fetchStudentsDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  if (loading) return <LoadingView message="Loading..." />;


  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const ViewUploadedDocuments = () => {
    return <Modal
      bodyStyle={{ height: 400 }}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      maskClosable={false}
      className="modalInfo"
      okText="Continue"
      cancelText="Back"
      centered
      footer={<div className=" flex justify-center sm:mb-4 xs:mb-4 gap-2">
        <button
          onClick={() => handleCancel()}
          className="w-24 h-8 text-base text-pink-500 hover:text-pink-500 bg-white hover:bg-white border border-pink-500 hover:border-pink-500 rounded-md">
          Cancel
        </button>
      </div>}
    >
      <img width={460} height={380} src={profileUser?.idCardUrl} alt={profileUser?.name} />
    </Modal>
  }
  return (
    <div className="container">
      <div className="headingContainer">
        <div className="headingTitle"></div>
        <div className="headingButton">

          <Button className="btn ant-btn ant-btn-primary" onClick={() => navigate(-1)}>Back</Button>
        </div>
        {ViewUploadedDocuments()}
      </div>
      <div className="resumeView">
        <div>
          <div className='profileHead'>
            <div className='userImg'>
              <Image src={studentInfo.profileUrl || 'https://www.shareicon.net/data/512x512/2016/07/26/802043_man_512x512.png'} preview={false} style={{ height: '144px', width: '144px' }} />

            </div>
            <div className='userInfo'>
              <h2>{studentInfo?.name}</h2>
              <p>{studentInfo?.email}</p>
            </div>
          </div>
          {
            studentInfo?.about !== null ? (
              <div className='aboutMe'>
                <h3>About Me</h3>
                <div className='resumeInfo'>
                  <p>{studentInfo?.about}</p>
                </div>
              </div>
            ) : null
          }


          <div className='contactDetails'>
            <h3>Contact Details</h3>
            <div className='resumeInfo'>
              <ul>
                {studentInfo?.email !== null ? (
                  <li>
                    <span className='head'>Email:</span>
                    <span className='info'>{studentInfo.email}</span>
                  </li>
                ) : null}
                {studentInfo?.phone !== null ? (
                  <li>
                    <span className='head'>Contact Number:</span>
                    <span className='info'>{studentInfo.phone}</span>
                  </li>
                ) : null}
                {studentInfo?.address !== null ? (
                  <li>
                    <span className='head'>Address:</span>
                    <span className='info'>{studentInfo?.address}</span>
                  </li>
                ) : null}
                {studentInfo?.dob !== null ? (
                  <li>
                    <span className='head'>Date of Birth:</span>
                    <span className='info'>{new Date(studentInfo.dob).toLocaleDateString('fr-FR')}</span>
                  </li>
                ) : null}
                {studentInfo?.gender !== null ? (
                  <li>
                    <span className='head'>Gender</span>
                    <span className='info camelCase'>{studentInfo?.gender?.replace(/_/g, " ")}</span>
                  </li>
                ) : null}
              </ul>
            </div>
          </div>

          {studentInfo?.education && studentInfo?.education[0]?.college &&
            <div className='contactDetails'>
              <h3>Educational Details</h3>
              <div className='resumeInfo'>
                <ul>
                  {studentInfo?.education?.map((edu, i) => {
                    return <React.Fragment key={i}>
                      <li>
                        <span className='head'>College Name:</span>
                        <span className='info'>{edu?.college}</span>
                      </li>
                      <li>
                        <span className='head'>Course :</span>
                        <span className='info'>{edu?.course}</span>
                      </li>
                      <li>
                        <span className='head'>Start Date :</span>
                        <span className='info'>{moment(edu?.start).format('DD-MM-YYYY')}</span>
                      </li>
                      <li>
                        <span className='head'>End Date :</span>
                        <span className='info'>{moment(edu?.end).format('DD-MM-YYYY')}</span>
                      </li>
                    </React.Fragment>
                  })}
                </ul>
              </div>
            </div>}
           <div className="contactDetails">
            <h3>Work Experience</h3>
            <div className="resumeInfo">
              {studentInfo?.workExperience?.length > 0 ? (
                <div className="experience-timeline">
                  {studentInfo.workExperience.map((exp, i) => (
                    <div key={i} className="timeline-item">
                      {/* The vertical connector and dot */}
                      <div className="timeline-visual">
                        <div className="dot" />
                        {i !== studentInfo.workExperience.length - 1 && (
                          <div className="line" />
                        )}
                      </div>

                      <div className="timeline-content">
                        <div className="exp-main-row">
                          <h4 className="company-name" title={exp?.companyName}>
                            {exp?.companyName}
                          </h4>
                          <span className="exp-date-range">
                            {moment(exp?.startDate).format("MMM YYYY")} —{" "}
                            {exp?.endDate
                              ? moment(exp?.endDate).format("MMM YYYY")
                              : "Present"}
                          </span>
                        </div>
                        <p className="exp-role-title" title={exp?.role}>
                          {exp?.role}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-data-msg">No work experience provided</div>
              )}
            </div>
          </div>

          {studentInfo?.languages.length !== 0 &&
            <div className='skillsDetails'>
              <h3>Languages</h3>
              <div className='resumeInfo'>
                <ul>
                  <li>{studentInfo?.languages.join(", ")}</li>
                </ul>
              </div>
            </div>}
          {studentInfo?.skills.length !== 0 &&
            <div className='skillsDetails'>
              <h3>Skills</h3>
              <div className='resumeInfo'>
                <ul>
                  <li>{studentInfo?.skills.join(", ")}</li>
                </ul>
              </div>
            </div>}


          {/* <div className='My Preferences'>
            <h3>Job Preferences</h3>
            <div className='resumeInfo'>
              <ul>
                <li>
                  <span className='head'>Preferred Timings:</span>
                  <span className='info'>9 AM to 1 PM</span>
                </li>
                <li>
                  <span className='head'>Preferred Work hours:</span>
                  <span className='info'>Work from home</span>
                </li>
              </ul>
            </div>
          </div> */}
          {
            studentInfo?.portfolio !== null ? (
              <div className='MyWorksAndLinks'>
                <h3>Student Portfolio</h3>
                <div className='resumeInfo studentPortFolio'>
                  <Row className='imgContainer' gutter={[40, 40]}>
                    {studentInfo?.portfolio.map((portfolio, i) => (
                      portfolio?.fileUrl !== null ? portfolio?.fileUrl.substr(portfolio?.fileUrl?.lastIndexOf('.') + 1) === 'png' ||
                        portfolio?.fileUrl.substr(portfolio?.fileUrl?.lastIndexOf('.') + 1) === 'jpg' ||
                        portfolio?.fileUrl.substr(portfolio?.fileUrl?.lastIndexOf('.') + 1) === 'jpeg' ? <Col className='imgContainer' xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 6 }}>
                        <div className='imgRow'>
                          <Image src={portfolio.fileUrl} preview={true} />
                        </div>
                      </Col> : null : null
                    ))}
                    {studentInfo?.portfolio.map((portfolio, i) => (
                      portfolio?.fileUrl !== null ? portfolio?.fileUrl.substr(portfolio?.fileUrl?.lastIndexOf('.') + 1) === 'pdf' ?
                        <Col className='imgContainer' xs={{ span: 24 }} sm={{ span: 12 }} lg={{ span: 6 }}>
                          <div className='imgRow'>
                            <a href={portfolio.fileUrl} rel="noopener noreferrer" target="_blank"><Image src={PdfImg} preview={false} /></a>
                          </div>
                        </Col> : null : null
                    ))}

                  </Row>
                  <div className='workLinks'>
                    {studentInfo?.portfolio?.map((portfolio, i) => (
                      <div>
                        <a href={portfolio?.workUrl} rel="noopener noreferrer" target="_blank">{portfolio?.workUrl}</a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null
          }

        </div>
      </div>
    </div>
  );
}
